import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { OrderDataImpl, OrderState, UserType } from "shared/cubiq-model-multi-asset";

/**
 * base for common func on FillPending MenuItems as they are the same (bar roles)
 */
export abstract class AbsBaseBfxBlotterOrdersContextFillMenuItem extends BfxBlotterOrdersContextMenuItem {
  constructor(
    public actionId: BfxBlotterAction,
    _title: string,
    checkAvailable: ContextMenuItemStateCommand<OrderDataImpl>,
    checkEnabled: ContextMenuItemStateCommand<OrderDataImpl>,
    public checkAvailableCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.MenuItem,
    public checkEnabledCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.Item,
  ) {
    super(
      actionId,
      _title,
      checkAvailable,
      checkEnabled,
      checkAvailableCriteria,
      checkEnabledCriteria,
    );
  }

  protected static testIfMenuAvailable(
    hasRoles: boolean,
    menuState: BfxBlotterOrdersContextMenuState,
    itemState: ContextMenuItemState,
    item: OrderDataImpl,
  ) {
    let amAllowed: Boolean = hasRoles;
    let isValidState: Boolean = false;
    let canActOn: Boolean = false;
    if (amAllowed && null != item) {
      isValidState = OrderState.FILL_PENDING == item.orderState;

      if (
        amAllowed &&
        isValidState &&
        menuState.activeUser &&
        (menuState.canAcceptUnrestricted ||
          (menuState.activeUser.tradingGroupsIdSet && item.deskId))
      ) {
        canActOn =
          menuState.canAcceptUnrestricted ||
          (item.deskId != null &&
            menuState.activeUser.tradingGroupsIdSet.has(item.deskId.toString()));
      }
    }
    let test: boolean = (amAllowed && isValidState && canActOn).valueOf();
    itemState.available = itemState.enabled = test;
  }
}
